import { Component, OnInit } from '@angular/core';
import { FrontOffService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pgenquiry',
  templateUrl: './pgenquiry.component.html',
  styleUrls: ['./pgenquiry.component.scss']
})
export class PgenquiryComponent implements OnInit {
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  tab=1;

  constructor(private modalService: NgbModal) { }

  openmodal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {
  }

}
